import Select from "react-select";
import NoDataComponent from "./NoData";
import i18n from "i18next";
import { useEffect, useMemo, useState } from "react";

interface CommonSelectLiteProps<T extends Record<string, any>> {
  options: T[];
  value?: any;
  onChange?: (value: any) => void;
  placeholder?: string;
  className?: string;
  optionValueKey: keyof T;
  optionLabelKey: keyof T;
  disabled?: boolean; // ✅ new prop
}

function CommonSelectLite<T extends Record<string, any>>({
  options,
  value,
  onChange,
  placeholder = i18n.t("select_item"),
  className,
  optionValueKey,
  optionLabelKey,
  disabled = false, // ✅ default false
}: CommonSelectLiteProps<T>) {
  // Map options internally
  const mappedOptions = options.map((opt) => ({
    value: opt[optionValueKey],
    label: opt[optionLabelKey],
  }));

  const selected = mappedOptions.find((opt) => opt.value === value) || null;

  return (
    <Select
      classNamePrefix="react-select"
      className={className}
      options={mappedOptions}
      value={selected}
      onChange={(option) => onChange?.(option ? option.value : null)}
      placeholder={placeholder}
      noOptionsMessage={() => <NoDataComponent />}
      // isClearable
      isDisabled={disabled} // ✅ hook into react-select
    />
  );
}

export default CommonSelectLite;
